<template>
    <div>
        <span>Attachment size (mb)</span>

        <div class="columns">
            <div class="column">
                <base-input
                    v-model="form.max_attachment_size"
                    name="size"
                    icon="fas fa-file-upload"
                    type="number"
                    validate="required|integer|min_value:1|max_value:50"/>
            </div>

            <div class="column is-narrow">
                <base-button
                    :loading="update.loading"
                    @click="update_attachment"
                    icon="fas fa-check"
                    class="is-primary"
                    text="Save"/>
            </div>
        </div>

        <div v-if="usage.loading" class="loader"></div>

        <template v-else>
            <span>Space usage </span>
            <b>({{usage.data.usage.toFixed(1)}}mb / {{space.storage_limit}}mb)</b><br/><br/>

            <progress
                class="progress is-success"
                :value="usage.data.usage"
                :max="space.storage_limit"></progress>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'SpaceSettingsStorage',
    props: ['space'],
    data() {
        return { form: { max_attachment_size: this.space.max_attachment_size || null } };
    },
    computed: mapState('spaces', ['detail', 'update', 'remove', 'usage']),
    created() {
        this.$store.dispatch('spaces/usage', { space_id: this.space.id });
    },
    methods: {
        update_attachment() {
            this.$store.dispatch('spaces/update', { space_id: this.space.id, data: this.form });
        },
    },
};
</script>
